import { BillsAvailable } from "interfaces";
import { Billing } from "interfaces/Billing";
import { get, post } from "services/services.methods";
import { ProvidersBillsPaths, SalesOrdersPaths } from "services/services.paths";

export const getBillsByProviders = async (providerId: string) => {
  const response = await get<BillsAvailable[]>(
    ProvidersBillsPaths.getAvailable + `/${providerId}`
  );

  return response.data;
};


export const createSalesRegistration = async (BillingOrder: Billing) => {
  const response = await post<any>(SalesOrdersPaths.post, BillingOrder);

  return response;
};


